import {Component, HostListener, Input} from '@angular/core';
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'user-not-found',
  templateUrl: './user-not-found.component.html',
  styleUrls: ['./user-not-found.component.scss']
})
export class UserNotFoundComponent {
  pageX: number;
  pageY: number;
  mouseX: number;
  mouseY: number;
  xAxis: number;
  yAxis: number;
  supportEmailAddress = environment.supportEmailAddress;

  @Input() isDisabled: boolean = false;

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mouseX = event.pageX;
    this.mouseY = event.pageY;
    this.pageY = window.innerHeight;
    this.pageX = window.innerWidth;

    this.yAxis = (this.pageY / 2 - this.mouseY) / this.pageY * 300;
    this.xAxis = -this.mouseX / this.pageX * 100;

    (document.querySelector('.box-ghost-eyes') as HTMLDivElement).style.transform = `translate(${this.xAxis}%, -${this.yAxis}%)`;
  }
}
